// INFO: There's an <ActionDrawer> component within the <OrgFile>
// component, as well.

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';

import './../../../OrgFile/components/ActionDrawer/stylesheet.css';

// import { syncBackend } from '../../../../actions';
// import { setCurrentFile } from '../../../../actions/ui';

import * as orgActions from '../../../../actions/org';
import * as syncActions from '../../../../actions/sync_backend';
import { formatDatePath } from '../../../../lib/dashboard';

import ActionButton from '../../../OrgFile/components/ActionDrawer/components/ActionButton';

const ensureCompleteFilename = (fileName) => {
  return fileName.endsWith('.org') ? fileName : `${fileName}.org`;
};

const ActionDrawer = ({ org, files, syncBackend, path, onFilterChange }) => {
  const history = useHistory();

  const handleDashboardClick = () => history.push('/dashboard');

  const handleAddNewOrgFileClick = () => {
    const content = '* First header\nExtend the file from here.';
    let fileName = prompt('New filename:');

    if (!fileName) return;

    fileName = ensureCompleteFilename(fileName);
    let newPath = `${path}/${fileName}`;

    if (_.includes(files, newPath)) {
      alert('File already exists. Aborting.');
    } else {
      syncBackend.createFile(newPath, content);
      org.addNewFile(newPath, content);
    }
  };

  // INFO: The filter is owned by <FileBrowser>. Setting the input's value from
  // here instead would leave React's own value tracking untouched, so the text
  // would appear in the field without the listing ever being filtered.
  // The guard stays from try-fw-o: a missing prop should complain, not fail silently.
  const handleFilter = (filterText) => {
    if (typeof onFilterChange !== 'function') {
      console.warn('<ActionDrawer> is missing the onFilterChange prop');
      return;
    }
    onFilterChange(filterText);
  };

  const handleFilterGTD = () => handleFilter('gtd.org');

  const handleFilterDaily = () => handleFilter(formatDatePath('YYYY-MM-DD.org'));

  const mainButtonStyle = {
    opacity: 1,
    position: 'relative',
    zIndex: 1,
  };

  return (
    <div className="action-drawer-container nice-scroll">
      {
        <Fragment>
          <div
            className="action-drawer__capture-buttons-container"
            style={{
              marginLeft: 'auto',
              marginRight: 0,
            }}
          >
            <ActionButton
              iconName="tachometer-alt"
              isDisabled={false}
              onClick={handleDashboardClick}
              style={mainButtonStyle}
              tooltip="Open dashboard"
            />
            <ActionButton
              iconName="plus"
              isDisabled={false}
              onClick={handleAddNewOrgFileClick}
              style={mainButtonStyle}
              tooltip="Add new Org file"
            />
            <ActionButton
              iconName="tasks"
              isDisabled={false}
              onClick={handleFilterGTD}
              style={mainButtonStyle}
              tooltip="Open GTD"
            />
            <ActionButton
              iconName="calendar-alt"
              isDisabled={false}
              onClick={handleFilterDaily}
              style={mainButtonStyle}
              tooltip="Open Daily Note"
            />
          </div>
        </Fragment>
      }
    </div>
  );
};

const mapStateToProps = (state) => {
  const path = state.syncBackend.get('currentPath');
  let files = state.syncBackend.getIn(['currentFileBrowserDirectoryListing', 'listing']);
  files = files ? files.map((e) => e.get('id')).toJS() : [];
  return {
    path,
    files,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    org: bindActionCreators(orgActions, dispatch),
    syncBackend: bindActionCreators(syncActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ActionDrawer);
